export function getActiveCatalogProducts(products = []) {
  return products.filter((product) => product.is_active === true)
    .slice().sort((left, right) => left.name.localeCompare(right.name, "fr", { sensitivity: "base" }));
}

export function getProductChoiceError(value, products, { originalValue, optional = false } = {}) {
  if (originalValue !== undefined && value === originalValue) return "";
  if (!value && optional) return "";
  return products.some((product) => product.is_active && product.name === value)
    ? "" : "Sélectionnez un produit actif dans le catalogue Produits.";
}
